import { useContext } from 'react'
import uniqid from 'uniqid'
import { LanguageContext } from '../../contexts/language'
import ExperienceContainer from '../ExperienceContainer/ExperienceContainer'
import './Experience.css'

const Experience = () => {
  const { portfolio, t } = useContext(LanguageContext)
  const { experience } = portfolio

  if (!experience.length) return null

  return (
    <section id='work-experience' className='section work-experience'>
      <h2 className='section__title'>{t.experience}</h2>

      <div className='work-experience__grid'>
        {experience.map((item) => (
          <ExperienceContainer key={uniqid()} experience={item} />
        ))}
      </div>
    </section>
  )
}

export default Experience
